import { h } from "./createElement";
import { __assign, __extends, __rest } from "tslib";
import * as React from 'react';
import { emptyFn, trueFn } from './helper';
import classNames from 'classnames';
import { DocumentDomContext } from './documentDom';
import memoizeOne from 'memoize-one';
export var TriggerContext = React.createContext(emptyFn);
var Trigger = (function (_super) {
    __extends(Trigger, _super);
    function Trigger() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.shouldCancel = false;
        _this.captureTrigger = function (e) {
            if (_this.props.disabled) {
                return;
            }
            setTimeout(function () {
                _this.trigger(e);
            }, 0);
        };
        _this.cancel = function (e) {
            if (_this.props.disabled) {
                return;
            }
            var event = e.nativeEvent;
            if (event._dui_trigger_instances) {
                event._dui_trigger_instances.push(_this);
            }
            else {
                event._dui_trigger_instances = [_this];
            }
        };
        _this.generateCancelSetter = memoizeOne(function (parentSetCancel) { return function (shouldCancel) {
            parentSetCancel(shouldCancel);
            _this.shouldCancel = shouldCancel;
        }; });
        return _this;
    }
    Trigger.prototype.componentDidMount = function () {
        this.doc.addEventListener('click', this.captureTrigger, true);
        if (!this.props.disableContextMenu) {
            this.doc.addEventListener('contextmenu', this.captureTrigger, true);
        }
    };
    Trigger.prototype.componentWillUnmount = function () {
        this.doc.removeEventListener('click', this.captureTrigger, true);
        if (!this.props.disableContextMenu) {
            this.doc.removeEventListener('contextmenu', this.captureTrigger, true);
        }
    };
    Object.defineProperty(Trigger.prototype, "doc", {
        get: function () {
            return this.context || document;
        },
        enumerable: false,
        configurable: true
    });
    Trigger.prototype.trigger = function (e) {
        var _a = this.props, disabled = _a.disabled, action = _a.action, shouldTriggerAction = _a.shouldTriggerAction;
        if (disabled || this.shouldCancel) {
            return;
        }
        if (e._dui_trigger_instances) {
            var index = e._dui_trigger_instances.indexOf(this);
            if (index !== -1) {
                e._dui_trigger_instances.splice(index, 1);
                if (e._dui_trigger_instances.length === 0) {
                    delete e._dui_trigger_instances;
                }
                return;
            }
        }
        if (shouldTriggerAction(e)) {
            action();
        }
    };
    Trigger.prototype.render = function () {
        var _this = this;
        var _a = this.props, prefixCls = _a.prefixCls, className = _a.className, style = _a.style, children = _a.children, domRef = _a.domRef, disableContextMenu = _a.disableContextMenu, testId = _a.testId, disabled = _a.disabled, action = _a.action, shouldTriggerAction = _a.shouldTriggerAction, rest = __rest(_a, ["prefixCls", "className", "style", "children", "domRef", "disableContextMenu", "testId", "disabled", "action", "shouldTriggerAction"]);
        var classes = classNames(prefixCls, className);
        return (h(TriggerContext.Consumer, null, function (parentSetCancel) { return (h(TriggerContext.Provider, { value: _this.generateCancelSetter(parentSetCancel) },
            h("div", __assign({ className: classes, style: style, onClickCapture: _this.cancel, onContextMenuCapture: disableContextMenu ? undefined : _this.cancel, ref: domRef, "data-testid": testId }, rest), children))); }));
    };
    Trigger.contextType = DocumentDomContext;
    return Trigger;
}(React.Component));
export default Trigger;
Trigger.defaultProps = {
    prefixCls: 'dui-trigger',
    action: emptyFn,
    shouldTriggerAction: trueFn,
    disabled: false,
    disableContextMenu: false,
};
